I18n.translations || (I18n.translations = {});
I18n.translations["en"] = I18n.extend((I18n.translations["en"] || {}), {});
I18n.translations["lv"] = I18n.extend((I18n.translations["lv"] || {}), {
  "about": {
    "company": {
      "description": "Neatkarīgs kredītu starpnieks, kas strādā Tavu interešu labā – salīdzinām vairākus aizdevējus, lai atrastu izdevīgāko piedāvājumu.",
      "title": "Uzticams Partneris Tavā Pusē"
    },
    "expertise": {
      "description": "Bez slēptiem nosacījumiem. Skaidri, saprotami un efektīvi – no pieteikuma līdz apstiprinājumam.",
      "title": "Ātri un Caurspīdīgi Risinājumi"
    },
    "security": {
      "description": "Rūpīgi glabājam Tavu informāciju un sadarbojamies tikai ar licencētiem un pārbaudītiem partneriem.",
      "title": "Drošība un Konfidencialitāte Garantēta"
    },
    "subtitle": "Mēs strādājam, lai piedāvātu Jums piemērotāko risinājumu",
    "team": {
      "description": "Klausāmies, saprotam un pielāgojamies – risinājumi, kas balstīti Tavās vajadzībās, nevis \"viens piedāvājums visiem\".",
      "title": "Individuāla Pieeja Katram Klientam"
    },
    "title": "Par Mums"
  },
  "activerecord": {
    "errors": {
      "messages": {
        "record_invalid": "Pārbaude neizdevās: %{errors}",
        "restrict_dependent_destroy": {
          "has_many": "Nevar dzēst ierakstu, jo ir atkarīgi %{record}",
          "has_one": "Nevar dzēst ierakstu, jo ir atkarīgs %{record}"
        }
      }
    }
  },
  "anchor_links": {
    "about_us": "par-mums",
    "business": "kredits-biznesam",
    "car": "auto-lizings",
    "consumer": "paterina-kredits",
    "contact": "kontakti",
    "faq": "biezak-uzdotie-jautajumi",
    "loan_application_form": "pieteikuma-forma",
    "mortage": "hipotekrais-kredits"
  },
  "contact": {
    "additional_info": "Mūsu komanda ir gatava atbildēt uz jebkuriem jautājumiem.",
    "address": "Bukultu iela 11, Rīga, Latvija",
    "address_title": "Adrese",
    "company_info": {
      "address": {
        "title": "Adrese",
        "value": "Bukultu iela 11, Rīga, Latvija"
      },
      "bank": {
        "title": "A/S \"Luminor Bank\"",
        "value": "LV47RIKO0002930366834"
      },
      "email": {
        "title": "E-pasts",
        "value": "info@kreditiem.lv"
      },
      "hours": {
        "title": "Darba Laiks",
        "value": "Pirmdiena - Piektdiena: 8:00 - 17:00"
      },
      "location": {
        "title": "Kā mūs atrast"
      },
      "name": {
        "title": "A/S Baltijas investīciju attīstības fonds",
        "value": "40103550907"
      },
      "phone": {
        "title": "Tālrunis",
        "value": "+371 251182216"
      },
      "title": "Uzņēmuma Informācija"
    },
    "copyright": "© %{year} AS Baltijas investīciju attīstības fonds. Visas tiesības aizsargātas.",
    "cta": "Sazinieties ar Mums",
    "email": "info@kreditiem.lv",
    "email_title": "E-pasts",
    "form": {
      "email": "E-pasts",
      "message": "Ziņojums",
      "message_placeholder": "Jūsu ziņojums...",
      "name": "Vārds",
      "phone": "Tālruņa Numurs",
      "sending": "Nosūta...",
      "submit": "Nosūtīt Ziņojumu",
      "surname": "Uzvārds",
      "title": "Raksti mums ziņu"
    },
    "hours_title": "Darba Laiks",
    "hours_weekdays": "Pirmdiena - Piektdiena: 8:00 - 17:00",
    "hours_weekend": "Sestdiena - Svētdiena: Slēgts",
    "messages": {
      "error": "Neizdevās nosūtīt ziņojumu. Lūdzu, mēģiniet vēlreiz.",
      "success": "Ziņojums veiksmīgi nosūtīts!"
    },
    "phone": "+371 251182216",
    "phone_title": "Tālrunis",
    "subtitle": "Sazinieties ar mūsu komandu",
    "title": "Kontakti"
  },
  "contact_mailer": {
    "question": "Jautājums"
  },
  "cookie_consent": {
    "accept": "Pieņemt visus",
    "decline": "Noraidīt",
    "message": "Mēs izmantojam sīkfailus, lai uzlabotu jūsu pārlūkošanas pieredzi, sniegtu personalizētu saturu un analizētu mūsu klientu plūsmu. Noklikšķinot uz \"Pieņemt visus\", jūs piekrītat mūsu sīkfailu izmantošanai.",
    "privacy_policy": "Izlasi mūsu Privātuma politiku"
  },
  "date": {
    "abbr_day_names": [
      "Sv.",
      "P.",
      "O.",
      "T.",
      "C.",
      "Pk.",
      "S."
    ],
    "abbr_month_names": [
      null,
      "Janv",
      "Febr",
      "Marts",
      "Apr",
      "Maijs",
      "Jūn",
      "Jūl",
      "Aug",
      "Sept",
      "Okt",
      "Nov",
      "Dec"
    ],
    "day_names": [
      "svētdiena",
      "pirmdiena",
      "otrdiena",
      "trešdiena",
      "ceturtdiena",
      "piektdiena",
      "sestdiena"
    ],
    "formats": {
      "default": "%d.%m.%Y.",
      "long": "%Y. gada %e. %B",
      "short": "%e. %B"
    },
    "month_names": [
      null,
      "janvārī",
      "februārī",
      "martā",
      "aprīlī",
      "maijā",
      "jūnijā",
      "jūlijā",
      "augustā",
      "septembrī",
      "oktobrī",
      "novembrī",
      "decembrī"
    ],
    "order": [
      "year",
      "month",
      "day"
    ]
  },
  "datetime": {
    "distance_in_words": {
      "about_x_hours": {
        "one": "apmēram %{count} stunda",
        "other": "apmēram %{count} stundas",
        "zero": "apmēram %{count} stundas"
      },
      "about_x_months": {
        "one": "apmēram %{count} mēnesis",
        "other": "apmēram %{count} mēneši",
        "zero": "apmēram %{count} mēneši"
      },
      "about_x_years": {
        "one": "apmēram %{count} gads",
        "other": "apmēram %{count} gadi",
        "zero": "apmēram %{count} gadi"
      },
      "almost_x_years": {
        "one": "gandrīz %{count} gads",
        "other": "gandrīz %{count} gadi",
        "zero": "gandrīz %{count} gadi"
      },
      "half_a_minute": "pusminūte",
      "less_than_x_minutes": {
        "one": "mazāk par %{count} minūti",
        "other": "mazāk par %{count} minūtēm",
        "zero": "mazāk par %{count} minūtēm"
      },
      "less_than_x_seconds": {
        "one": "mazāk par %{count} sekundi",
        "other": "mazāk par %{count} sekundēm",
        "zero": "mazāk par %{count} sekundēm"
      },
      "over_x_years": {
        "one": "vairāk kā %{count} gads",
        "other": "vairāk kā %{count} gadi",
        "zero": "vairāk kā %{count} gadi"
      },
      "x_days": {
        "one": "%{count} diena",
        "other": "%{count} dienas",
        "zero": "%{count} dienas"
      },
      "x_minutes": {
        "one": "%{count} minūte",
        "other": "%{count} minūtes",
        "zero": "%{count} minūtes"
      },
      "x_months": {
        "one": "%{count} mēnesis",
        "other": "%{count} mēneši",
        "zero": "%{count} mēneši"
      },
      "x_seconds": {
        "one": "%{count} sekunde",
        "other": "%{count} sekundes",
        "zero": "%{count} sekundes"
      }
    },
    "prompts": {
      "day": "diena",
      "hour": "stunda",
      "minute": "minūte",
      "month": "mēnesis",
      "second": "sekunde",
      "year": "gads"
    }
  },
  "errors": {
    "format": "%{attribute} %{message}",
    "messages": {
      "accepted": "ir jāpiekrīt",
      "blank": "ir jābūt aizpildītam",
      "confirmation": "nesakrīt ar apstiprinājumu",
      "empty": "ir jābūt aizpildītam",
      "equal_to": "ir jābūt vienādam ar %{count}",
      "even": "ir jābūt pāra skaitlim",
      "exclusion": "nav pieejams",
      "greater_than": "ir jābūt lielākam par %{count}",
      "greater_than_or_equal_to": "ir jābūt lielākam vai vienādam ar %{count}",
      "inclusion": "nav iekļauts sarakstā",
      "invalid": "nav derīgs",
      "less_than": "ir jābūt mazākam par %{count}",
      "less_than_or_equal_to": "ir jābūt mazākam vai vienādam ar %{count}",
      "model_invalid": "Validācija neizdevās: %{errors}",
      "not_a_number": "nav skaitlis",
      "not_an_integer": "ir jābūt veselam skaitlim",
      "odd": "ir jābūt nepāra skaitlim",
      "other_than": "jābūt citam nekā %{count}",
      "present": "jābūt tukšam",
      "required": "ir jābūt",
      "taken": "ir jau aizņemts",
      "too_long": {
        "one": "ir par garu (maksimums ir %{count} simbols)",
        "other": "ir par garu (maksimums ir %{count} simboli)",
        "zero": "ir par garu (maksimums ir %{count} simboli)"
      },
      "too_short": {
        "one": "ir par īsu (minimums ir %{count} simbols)",
        "other": "ir par īsu (minimums ir %{count} simboli)",
        "zero": "ir par īsu (minimums ir %{count} simboli)"
      },
      "wrong_length": {
        "one": "ir nepareizs garums (jābūt %{count} simbolam)",
        "other": "ir nepareizs garums (jābūt %{count} simboliem)",
        "zero": "ir nepareizs garums (jābūt %{count} simboliem)"
      }
    },
    "template": {
      "body": "Problēmas ir šajos ievades laukos:",
      "header": {
        "one": "Dēļ %{count} kļūdas šis %{model} netika saglabāts",
        "other": "Dēļ %{count} kļūdām šis %{model} netika saglabāts",
        "zero": "Dēļ %{count} kļūdām šis %{model} netika saglabāts"
      }
    }
  },
  "faq": {
    "contact_text": "Joprojām ir jautājumi? Mūsu komanda ir gatava palīdzēt.",
    "eligibility": {
      "answer": "Pēc pozitīva kredīta lēmuma līdzekļi kontā var tikt ieskaitīti pāris stundu vai dienu laikā – atkarībā no izvēlētā aizdevēja un kredīta veida.",
      "question": "Cik ilgā laikā varu saņemt naudu savā kontā?"
    },
    "process": {
      "answer": "Jā, dažos gadījumos kredīts ar ķīlu vai galvotāju var palielināt iespējas saņemt finansējumu vai iegūt labākus nosacījumus.",
      "question": "Vai ir iespējams saņemt kredītu ar galvotāju vai ķīlu?"
    },
    "requirements": {
      "answer": "Jā, katrs gadījums tiek vērtēts individuāli. Daži aizdevēji pieņem arī alternatīvus ienākumu avotus – piemēram, pašnodarbinātību vai īres ienākumus.",
      "question": "Vai varu pieteikties, ja neesmu oficiāli nodarbināts?"
    },
    "subtitle": "Atrodiet atbildes uz biežāk uzdotajiem jautājumiem par mūsu kredīta procesu",
    "timeframe": {
      "answer": "Jā, kredītvēsture tiek ņemta vērā, taču mēs sadarbojamies ar vairākiem aizdevējiem, arī tādiem, kas piedāvā risinājumus klientiem ar iepriekšējām kavējuma atzīmēm.",
      "question": "Vai mans kredītreitings ietekmē iespējas saņemt aizdevumu?"
    },
    "title": "Biežāk Uzdotie Jautājumi"
  },
  "features": {
    "description": "Mēs palīdzam atrast ne tikai labāko aizdevēju, bet arī padarām visu procesu ātru, skaidru un drošu – lai rezultāts tiešām atbilstu tavām vajadzībām.",
    "flexible_terms": {
      "description": "Nosaki sev ērtāko termiņu pats",
      "title": "Elastīgi Nosacījumi"
    },
    "great_rates": {
      "description": "Izvēlies sev piemērotāko",
      "title": "Caurspīdīgums"
    },
    "personal_support": {
      "description": "Zinoši kredīta speciālisti, kas palīdzēs",
      "title": "Personīgs Atbalsts"
    },
    "quick_approval": {
      "description": "Saņemiet atbildi 1 darba dienas laikā",
      "title": "Ātra Apstiprināšana"
    },
    "quick_process": {
      "description": "Saņemiet lēmumu 1 darba dienas laikā",
      "title": "Ātrs process"
    },
    "secure_process": {
      "description": "Jūsu dati ir aizsargāti ar augstākā līmeņa drošību",
      "title": "Drošs Process"
    },
    "title": "Kāpēc izvēlēties mūs?"
  },
  "floating_button": {
    "aria_label": "Pāriet uz kredīta pieteikuma veidlapu",
    "text": "Pieteikties Tagad!"
  },
  "footer": {
    "business_hours": {
      "title": "Darba Laiks",
      "weekdays": "Pirmdiena - Piektdiena: 8:00 - 17:00",
      "weekend": "Sestdiena - Svētdiena: Slēgts"
    },
    "contact": {
      "address_title": "Adrese",
      "email": "info@kreditiem.lv",
      "email_title": "E-pasts",
      "phone": "+371 25182216",
      "phone_title": "Tālrunis",
      "subtitle": "Sazinieties ar mūsu komandu",
      "title": "Kontakti"
    },
    "copyright": "© %{year} AS Baltijas investīciju un attīstības fonds. Visas tiesības aizsargātas.",
    "disclaimer": "Pilnvaru apjoms - neatkarīgs brokeris.",
    "legal": {
      "privacy": "Privātuma Politika",
      "terms": "Lietošanas Noteikumi",
      "title": "Juridiska Informācija"
    },
    "quick_links": {
      "about": "Par Mums",
      "contact": "Kontakti",
      "faq": "BUJ",
      "services": "Pakalpojumi",
      "title": "Ātrās Saites"
    },
    "social": {
      "title": "Meklē mūs arī"
    }
  },
  "form": {
    "and": "un",
    "buttons": {
      "next": "Tālāk",
      "previous": "Atpakaļ"
    },
    "documents_help": "Lai varētu izvērtēt jūsu pieteikumu, lūdzu, pievienojiet bankas konta pārskatus par pēdējiem 6 mēnešiem.",
    "family_status": {
      "married": "Precējies",
      "single": "Neprecējies"
    },
    "fields": {
      "addresses_match": "Mana faktiskā adrese sakrīt ar deklarēto adresi",
      "agree_to_terms": "Es piekrītu",
      "bank_account": "Bankas Konta Numurs (IBAN)",
      "city": "Pilsēta / Ciems",
      "declared_address": "Deklarētā Adrese",
      "dependent_persons": "Apgādībā esošo personu skaits",
      "email": "E-pasts",
      "factical_address": "Faktiskā Adrese",
      "family_status": "Ģimenes Stāvoklis",
      "first_name": "Vārds",
      "job_type": "Nodarbošanās Veids",
      "last_name": "Uzvārds",
      "loan_amount": "Kredīta Summa",
      "loan_period": "Kredīta Termiņš",
      "loan_type": "Kredīta Veids",
      "personal_code": "Personas Kods",
      "phone": "Tālruņa Numurs",
      "upload_documents": "Ātrākai pieteikuma izskatīšanai pievieno bankas konta pārskatu"
    },
    "job_type": {
      "other": "Cits",
      "permanent": "Patstāvīgs darbs",
      "retired": "Pensionārs",
      "self_employed": "Pašnodarbināts",
      "student": "Students",
      "temporary": "Darbs uz noteiktu laiku",
      "unemployed": "Bezdarbnieks"
    },
    "links": {
      "privacy_policy": "Privātuma Politikai",
      "terms": "Lietošanas Noteikumiem"
    },
    "loan_types": {
      "business": "Uzņēmumu Kredīts",
      "car": "Auto Līzings",
      "consumer": "Patēriņa Kredīts",
      "mortgage": "Hipotekārais Kredīts"
    },
    "messages": {
      "error": "Kļūda iesniedzot pieteikumu: %{message}",
      "file_upload_error": "Kļūda augšupielādējot failu: %{message}",
      "file_upload_max": "Sasniegts maksimālais failu skaits",
      "file_upload_removed": "Fails dzēsts",
      "file_upload_size": "Faila izmērs pārsniedz ierobežojumu",
      "file_upload_success": "Fails veiksmīgi augšupielādēts",
      "file_upload_type": "Nederīgs faila tips",
      "loading": "Ielādē...",
      "network_error": "Tīkla kļūda. Lūdzu, mēģiniet vēlreiz.",
      "processing": "Jūsu pieteikums tiek apstrādāts...",
      "saving": "Saglabā...",
      "success": "Pieteikums veiksmīgi iesniegts!",
      "success_subtitle": "Drīzumā ar Jums sazināsimies",
      "uploading": "Augšupielādē..."
    },
    "months": "mēneši",
    "placeholders": {
      "bank_account": "LV80BANK0000435195001",
      "city": "Ievadiet savu pilsētu",
      "personal_code": "123456-12345",
      "phone": "+371 12345678"
    },
    "sections": {
      "address_info": "Adreses Informācija",
      "banking_info": "Bankas Informācija",
      "family_info": "Ģimenes Informācija",
      "loan_details": "Kredīta Informācija",
      "personal_info": "Personīgā Informācija"
    },
    "steps": {
      "1": "Personīgie dati",
      "2": "Kredīta dati",
      "3": "Adreses dati",
      "4": "Ģimenes dati",
      "5": "Bankas dati"
    },
    "submit": "Iesniegt Pieteikumu",
    "title": "Pieteikties Tagad!",
    "validation": {
      "address": "Lūdzu, ievadiet derīgu adresi",
      "bank_account": "Nederīgs IBAN formāts",
      "email": "Nederīgs e-pasta formāts",
      "file_size": "Faila izmēram jābūt mazākam par %{size}MB",
      "file_type": "Nederīgs faila tips. Atļautie tipi: %{types}",
      "max_amount": "Maksimālā kredīta summa ir %{amount}€",
      "max_period": "Maksimālais kredīta termiņš ir %{period} mēneši",
      "min_amount": "Minimālā kredīta summa ir %{amount}€",
      "min_period": "Minimālais kredīta termiņš ir %{period} mēneši",
      "personal_code": "Personas kodam jābūt formātā 123456-12345",
      "phone": "Tālrunim jāsatur tikai cipari",
      "required": "%{field} ir obligāts lauks",
      "terms_required": "Jums jāpiekrīt lietošanas noteikumiem",
      "too_long": "%{field} nedrīkst pārsniegt %{count} rakstzīmes",
      "too_short": "%{field} jābūt vismaz %{count} rakstzīmēm"
    }
  },
  "header": {
    "logo": {
      "description": "Individuāli finanšu risinājumi",
      "title": "Kredītiem.lv"
    }
  },
  "helpers": {
    "select": {
      "prompt": "Lūdzu izvēlies"
    },
    "submit": {
      "create": "Izveidot %{model}",
      "submit": "Saglabāt %{model}",
      "update": "Atjaunināt %{model}"
    }
  },
  "hero": {
    "cta": "Pieteikties Tagad!",
    "description": "Piesakies finansējumam un saņem individuālu piedāvājumu vien 24 stundu laikā!",
    "title": "Individuāls finansējuma piedāvājums tieši tev"
  },
  "i18n": {
    "plural": {
      "keys": [
        "one",
        "other"
      ]
    }
  },
  "languages": {
    "en": "English",
    "lv": "Latviešu",
    "ru": "Русский",
    "select_language": "Izvēlies valodu"
  },
  "loading": {
    "title": "Piesakies finansējumam un saņem individuālu piedāvājumu vien 24 stundu laikā!"
  },
  "loan_types": {
    "business": {
      "description": "Līdz €250,000 jūsu biznesa vajadzībām",
      "title": "Kredīts biznesam"
    },
    "car": {
      "description": "Līdz €100,000 jūsu jaunajam transportlīdzeklim",
      "title": "Auto Līzings"
    },
    "consumer": {
      "description": "Līdz €20,000 personīgajām vajadzībām",
      "title": "Patēriņa Kredīti"
    },
    "mortgage": {
      "description": "Līdz €500,000 jūsu sapņu mājai",
      "title": "Hipotekārie Kredīti"
    },
    "title": "Aizdevumu veidi"
  },
  "loan_types_page": {
    "benefits": {
      "title": "Ieguvumi"
    },
    "business": {
      "benefits": {
        "accessible": "Pieejami - Līguma darbības laikā saņem atbildes uz jautājumiem no sava konsultanta",
        "convenient": "Ērti - Noslēdz darījumu attālināti, neizejot no mājām",
        "fast": "Ātri - Līgumu paraksti elektroniski ar SMART-ID vai e-Paraksts",
        "pause": "Apturi - Iespējams atliktais maksājums līdz pat sešiem mēnešiem",
        "profitable": "Izdevīgi - Atgriez aizdevumu ātrāk vai saņem papildus summu ja nepieciešams",
        "quality": "Kvalitatīvi - Saņem individuāli tavam biznesam pielāgotu maksājuma grafiku"
      },
      "description": "Esošajiem vai topošajiem saimnieciskās darbības veicējiem apgrozāmajiem līdzekļiem, darba materiālu/tehnikas iegādei vai uzņēmējdarbības uzsākšanai.",
      "details": {
        "security": "Kredīts tiek izsniegts tikai ar nekustamā īpašuma nodrošinājumu.",
        "suitable": "Kredīts biznesam ir piemērots risinājums pašnodarbinātām personām, kuras plāno uzsākt vai veic saimniecisko darbību, zemnieku saimniecībām, kā arī uzņēmējiem, kuriem nepieciešami apgrozāmie līdzekļi."
      },
      "faq": {
        "early_repayment": {
          "answer": "Jā, kredītu pirms termiņa iespējams atdot ātrāk.",
          "question": "Vai iespējams kredītu atdot ātrāk?"
        },
        "partial_funding": {
          "answer": "Steidzamu biznesa jautājumu risināšanai, varam izvērtēt daļu finansējuma izsniegt līguma parakstīšanas dienā.",
          "question": "Vai daļu kredīta iespējams saņemt uzreiz?"
        },
        "purpose_check": {
          "answer": "Mēs aicināsim Jūs mūs informēt par kredīta izmantošanas mērķi.",
          "question": "Vai tiks pārbaudīts kredīta izmantošanas mērķis?"
        }
      },
      "period": "Līdz 15 gadiem",
      "rate": "No 9% + EURIBOR gadā",
      "security": "Nekustamais īpašums",
      "title": "Kredīts biznesam"
    },
    "car": {
      "benefits": {
        "accessible": "Pieejami - Remonta gadījumā auto remontē pie brīvi izvēlēta oficiāla auto servisa",
        "convenient": "Ērti - Mēneša maksājums ietver nomas maksu, KASKO un OCTA"
      },
      "description": "Kredītiem.lv sadarbības partneri piedāvās Jums pilna servisa auto līzingu jaunām vai mazlietotām automašīnām. Šo pakalpojumu var izmantot gan privātpersonas, gan uzņēmēji.",
      "details": {
        "full_service": "Kredītiem.lv sadarbības partneri piedāvā Jums pilna servisa auto līzingu jaunām vai mazlietotām automašīnām. Šo pakalpojumu var izmantot gan privātpersonas, gan uzņēmēji.",
        "partners": "Mūsu sadarbības partneri piedāvā dažādus risinājumus, tai skaitā auto iegādi bez pirmās iemaksas."
      },
      "faq": {
        "buyout": {
          "answer": "Jā, Jūs variet auto izpirkt vai atdot to iznomātājiem.",
          "question": "Vai iespējams pēc 3 gadu auto nomas to izpirkt?"
        },
        "down_payment": {
          "answer": "Mūsu sadarbības partneri piedāvā dažādus risinājumus, tai skaitā auto iegādi bez pirmās iemaksas.",
          "question": "Vai man jābūt pirmajai iemaksai?"
        },
        "extension": {
          "answer": "Nē, konkrētajam auto jūs pagarināt līgumu nevarēsiet, tas būs jāizpērk vai jānodod iznomātājam (saskaņā ar līgumu kādu slēdziet), bet Jūs variet izvēlēties jaunu auto un noslēgt jaunu darījumu.",
          "question": "Vai es varu pagarināt pilna servisa auto nomu pēc 3 gadiem?"
        }
      },
      "period": "Līdz 3 gadiem",
      "rate": "Bez pirmās iemaksas",
      "security": "Pilna servisa (OCTA + KASKO iekļauts)",
      "title": "Auto līzings"
    },
    "consumer": {
      "benefits": {
        "accessible": "Pieejami - Nav nepieciešams nodrošinājums, izskatīšana no 15 minūtēm",
        "convenient": "Ērti - Ātrs un vienkāršs risinājums steidzamiem jautājumiem, kurus nevajag atlikt",
        "fast": "Ātri - Pieteikuma izskatīšana no 15 minūtēm",
        "pause": "Elastīgi - Dažādi atmaksas termiņi no 3 mēnešiem līdz 10 gadiem",
        "profitable": "Izdevīgi - Konkurētspējīgas procentu likmes sākot no 6,9%",
        "quality": "Kvalitatīvi - Individualizēts piedāvājums, kas pielāgots Jūsu situācijai"
      },
      "description": "Atbalsts Jūsu plāniem - lielākiem pirkumiem, mājokļa labiekārtošanai, neparedzētiem izdevumiem, atpūtai vai dažādām situācijām.",
      "details": {
        "security": "Nav nepieciešams nodrošinājums. Aizdevuma summa no €100 līdz €20,000 ar elastīgiem atmaksas nosacījumiem.",
        "suitable": "Patēriņa kredīts ir piemērots, kad nepieciešams ātri un ērti atrisināt jautājumus, kurus nevajag atlikt. Ideāls lielākiem pirkumiem, mājokļa labiekārtošanai, neparedzētiem izdevumiem, atpūtai vai dažādām dzīves situācijām."
      },
      "faq": {
        "early_repayment": {
          "answer": "Jā, priekšlaicīga atmaksa ir iespējama bez papildus komisijām.",
          "question": "Vai iespējams kredītu atdot ātrāk?"
        },
        "partial_funding": {
          "answer": "Jūs varat aizņemties no €100 līdz €20,000 atkarībā no Jūsu ienākumiem un kredītspējas.",
          "question": "Kāda ir minimālā un maksimālā aizdevuma summa?"
        },
        "purpose_check": {
          "answer": "Patēriņa kredītu var izmantot Jūsu izvēlētiem mērķiem - mēs neierobežojam līdzekļu izmantošanu.",
          "question": "Vai tiks pārbaudīts kredīta izmantošanas mērķis?"
        }
      },
      "period": "3 mēneši - 10 gadi",
      "rate": "No 6,9% gadā",
      "security": "Nav nepieciešams nodrošinājums",
      "title": "Patēriņa kredīts"
    },
    "cta": {
      "button": "Pieteikties tagad!",
      "description": "Sāc savu pieteikumu šodien un saņem individuālu piedāvājumu 24 stundu laikā.",
      "title": "Gatavs pieteikties?"
    },
    "details": {
      "title": "Detalizēta informācija"
    },
    "faq": {
      "title": "Biežāk uzdotie jautājumi"
    },
    "hero": {
      "description": "Izvēlieties finansējuma risinājumu, kas vislabāk atbilst jūsu vajadzībām. Mēs piedāvājam dažādus kredītu veidus ar konkurētspējīgiem nosacījumiem un individuālu pieeju.",
      "title": "Kredītu veidi"
    },
    "how_to_apply": {
      "step1": {
        "description": "Aizpildi pieteikuma veidlapu un saņem piedāvājumu e-pastā",
        "title": "Aizpildi pieteikumu"
      },
      "step2": {
        "description": "Apstiprini līgumu ar elektronisko parakstu vai saņem to ar kurjeru",
        "title": "Apstiprini līgumu"
      },
      "step3": {
        "description": "Saņem kredītu savā kontā un novirzi to plānotajam mērķim",
        "title": "Saņem līdzekļus"
      },
      "title": "Kā pieteikties"
    },
    "info": {
      "period": "Periods",
      "rate": "Procentu likme",
      "security": "Nodrošinājums"
    },
    "mortgage": {
      "benefits": {
        "accessible": "Pieejami - Līguma darbības laikā saņem atbildes uz jautājumiem no sava konsultanta",
        "convenient": "Ērti - Noslēdz darījumu attālināti, neizejot no mājām",
        "fast": "Ātri - Līgumu paraksti elektroniski ar SMART-ID vai e-Paraksts",
        "pause": "Apturi - Iespējams atliktais maksājums līdz pat sešiem mēnešiem",
        "profitable": "Izdevīgi - Atgriez aizdevumu ātrāk vai saņem papildus summu ja nepieciešams",
        "quality": "Kvalitatīvi - Saņem individuāli tavam biznesam pielāgotu maksājuma grafiku"
      },
      "description": "Aizdevums ar nekustamā īpašuma ķīlas nodrošinājumu. Īpašuma iegādei, esoša aizdevuma pārkreditācijai vai esoša īpašuma ieķīlāšana.",
      "details": {
        "evaluation": "Šajā gadījumā ķīlas vērtība tiek noteikta ar sertificēta vērtētāja palīdzību, apsekojot Jūsu nekustamo īpašumu. Galvenokārt pirmreizēji kredīta pieteikumi tiek izskatīti 1 darba dienas laikā, sniedzot klientam operatīvu atbildi par iespējamo kredīta piešķiršanu.",
        "processing": "Bet ir arī gadījumi, kad nepieciešama padziļinātāka izvērtēšana, kas var aizņemt līdz par 3-5 darba dienām. Šādā gadījumā klients telefoniski tiek informēts par izvērtēšanas termiņu. Saņemtais aizdevums tiek novirzīts pieteikumā paredzētajam mērķim.",
        "suitable": "Kredīts pret nekustamā īpašuma ķīlu ir piemērots risinājums fiziskām vai juridiskām personām, kurām pieder nekustamais īpašums. Tas ir ilgtermiņa darījums, kas tiek nodrošināts ar nekustamā īpašuma ķīlu. Kredīts klientam tiek piešķirts līdz pat 75% apmērā no ķīlas vērtības un tiek izsniegts personām, kuras sasniegušas vismaz 18 gadu vecumu."
      },
      "faq": {
        "early_repayment": {
          "answer": "Jā, kredītu pirms termiņa iespējams atdot ātrāk.",
          "question": "Vai iespējams kredītu atdot ātrāk?"
        },
        "partial_funding": {
          "answer": "Steidzamu biznesa jautājumu risināšanai, varam izvērtēt daļu finansējuma izsniegt līguma parakstīšanas dienā.",
          "question": "Vai daļu kredīta iespējams saņemt uzreiz?"
        },
        "purpose_check": {
          "answer": "Mēs aicināsim Jūs mūs informēt par kredīta izmantošanas mērķi.",
          "question": "Vai tiks pārbaudīts kredīta izmantošanas mērķis?"
        }
      },
      "period": "Līdz 15 gadiem",
      "rate": "No 9% + EURIBOR gadā",
      "security": "Nekustamais īpašums",
      "title": "Hipotekārais kredīts"
    }
  },
  "loan_use_cases": {
    "business_development": "Uzņēmuma attīstībai",
    "dream_vacation": "Sapņu ceļojumam",
    "for_daily_use": "Ikdienas tēriņiem",
    "new_car": "Jaunam auto",
    "perfect_home": "Perfektajam mājoklim"
  },
  "meta": {
    "contact_title": "Sazinieties ar mums | Kreditiem.lv",
    "description": "Piesakieties kredītam un uzzini savas finanšu iespējas jau šodien",
    "keywords": "aizdevums, hipotekārais kredīts, kredīts, finansējums, biznesa aizdevums, patēriņa kredīts, lauksaimniecības aizdevums",
    "loan_types_title": "Kredītu veidi | Kreditiem.lv",
    "og_description": "Saņemiet personalizētu finansiālo atbalstu ar mūsu pārbaudītajiem finanšu pakalpojumiem",
    "og_title": "Kreditiem.lv - Individuāli Finanšu Risinājumi",
    "title": "Kredīta Pieteikums"
  },
  "number": {
    "currency": {
      "format": {
        "delimiter": ".",
        "format": "%n %u",
        "precision": 2,
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false,
        "unit": "€"
      }
    },
    "format": {
      "delimiter": ".",
      "precision": 2,
      "separator": ",",
      "significant": false,
      "strip_insignificant_zeros": false
    },
    "human": {
      "decimal_units": {
        "format": "%n %u",
        "units": {
          "billion": {
            "one": "miljards",
            "other": "miljardi",
            "zero": "miljardi"
          },
          "million": {
            "one": "miljons",
            "other": "miljoni",
            "zero": "miljoni"
          },
          "quadrillion": {
            "one": "kvadriljons",
            "other": "kvadriljoni",
            "zero": "kvadriljoni"
          },
          "thousand": {
            "one": "tūkstotis",
            "other": "tūkstoši",
            "zero": "tūkstoši"
          },
          "trillion": {
            "one": "triljons",
            "other": "triljoni",
            "zero": "triljoni"
          },
          "unit": ""
        }
      },
      "format": {
        "delimiter": "",
        "precision": 1,
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": {
            "one": "baits",
            "other": "baiti",
            "zero": "baiti"
          },
          "eb": "EB",
          "gb": "GB",
          "kb": "KB",
          "mb": "MB",
          "pb": "PB",
          "tb": "TB"
        }
      }
    },
    "nth": {
      "ordinalized": "%{number}.",
      "ordinals": "."
    },
    "percentage": {
      "format": {
        "delimiter": "",
        "format": "%n%"
      }
    },
    "precision": {
      "format": {
        "delimiter": ""
      }
    }
  },
  "routes": {
    "contact": "kontakti",
    "loan_types": "kreditu-veidi"
  },
  "support": {
    "array": {
      "last_word_connector": " un ",
      "two_words_connector": " un ",
      "words_connector": ", "
    }
  },
  "time": {
    "am": "priekšpusdiena",
    "formats": {
      "default": "%Y. gada %e. %B, %H:%M",
      "long": "%Y. gada %e. %B, %H:%M:%S",
      "short": "%d.%m.%Y., %H:%M"
    },
    "pm": "pēcpusdiena"
  }
});
I18n.translations["ru"] = I18n.extend((I18n.translations["ru"] || {}), {});
